import { RootState } from '../reducers'

export const menuSelector = (state: RootState) => state.menu
